import { env } from "../configuration/config";
import type { Environment } from "../configuration/config";

export class HttpResponseError extends Error {
    readonly status: number;
    readonly statusText: string;
    readonly response: Response;

    constructor(response: Response) {
        super(`HTTP ${response.status} ${response.statusText}`);
        this.name = 'HttpResponseError';
        this.status = response.status;
        this.statusText = response.statusText;
        this.response = response;
    }
}

class Resource {
    private get config(): Environment {
        if (!env.config) {
            throw new Error('Environment has not been initialized.');
        }
        console.log('Resource config:', env.config);
        return env.config;
    }

    getEnv(): string {
        return this.config.environment;
    }

    getSesApi(): string {
        return this.config.webApiUrl + "/starter";
    }

    getWebApiUrl(): string {
        return this.config.webApiUrl;
    }

    getWebApiKey(): string {
        return this.config.webApiKey;
    }

    getAdfsUrl(): string {
        return this.config.adfsUrl;
    }

    getEntraIdClientId(): string {
        return this.config.entraIdClientId;
    }

    getEntraIdApiKey(): string {
        return this.config.entraIdApiKey;
    }

    getEntraIdUrl(): string {
        return this.config.entraIdUrl;
    }

    getEntraIdPreferredDomain(): Environment['entraIdPreferredDomain'] {
        return this.config.entraIdPreferredDomain;
    }

    isEntraIdForced(): boolean {
        return this.config.entraIdForced ?? false;
    }

    checkStatus(response: Response): Response | Promise<never> {
        if (response.status >= 200 && response.status < 300) {
            return response;
        } else {
            return Promise.reject(new HttpResponseError(response));
        }
    }

    getJsonBody(response: Response): Promise<unknown> {
        if (response.status === 204) {
            return Promise.resolve();
        }

        return response.json();
    }

}

const serverResource = new Resource();
export default serverResource;

